import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PaymentApi } from '../../api/PaymentApi';
import { PageRelativePath, RegistrationState } from '../../consts/Common';
import { JourneyState } from '../common/CommonTypes';
import LoadingContainer from '../common/LoadingContainer/LoadingContainer';
import PageHeader from '../common/PageHeader';
import { useJourney } from './Layout';

const PaymentAssistSuccess = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('token') ?? searchParams.get('id') ?? '';
  const navigate = useNavigate();
  const { journey, onRegister, onSetJourney } = useJourney();
  const { personalDetail, registrationState } = journey;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchJourneyState(signal: AbortSignal) {
      const fetchJourneyStateSuccess = (journeyState: JourneyState) => {
        onSetJourney(journeyState);
      };

      const fetchJourneyStateFailure = (error: string) => {
        console.log(error);
        setLoading(false);
      };

      await new PaymentApi().getPaymentAssistState(
        id,
        fetchJourneyStateSuccess,
        fetchJourneyStateFailure,
        signal
      );
    }

    fetchJourneyState(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if (personalDetail?.surname) {
      onRegister(id, '');
    }
  }, [personalDetail?.surname]);

  useEffect(() => {
    if (registrationState === RegistrationState.Success) {
      navigate(PageRelativePath.Confirmation);
    } else if (registrationState === RegistrationState.Failed) {
      navigate(PageRelativePath.CustomerFailedRegistration);
    }
  }, [registrationState]);

  return (
    <div>
      <PageHeader title='Payment Assist Completed' description='' />
      <LoadingContainer
        loading={loading}
        message='Please wait'></LoadingContainer>
    </div>
  );
};

export default PaymentAssistSuccess;
